module.exports = __webpack_public_path__ + "assets/img/presentation.c8dc1fd7.jpg";